module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/isolated-subscription/isolated-subscription.component.css
// module id = ./src/app/Screens/isolated-subscription/isolated-subscription.component.css
// module chunks = main